export const AUTHORIZATION_URI = '/authorize';
export const USER_INFO_URI = '/userinfo';
export const LOGOUT_URI = '/logout';
export const NOTIFICATION_PATH = 'notification/addNotification';